module.exports = __webpack_public_path__ + "static/media/clue02.0a8ce6d0.jpg";